import { createAction } from '@reduxjs/toolkit';

export class GetCurrentLocationFailure {
  static get action() {
    return createAction('profile/GET_CURRENT_LOCATION_FAILURE');
  }
}
